/**
* @summary - Component that Provides WORK ORDER RESCHEDULE functionality
* @autor vengateshwaran k
* @since 2024-06-21
*/
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from "@mui/material";
import { format, parse, parseISO } from 'date-fns';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import workOrderResscheduleRepository from "../../api/repositories/workOrderResscheduleRepository";
import { DefaultCard } from "../../assets/styled-components/card";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import commonMessages from "../../utility/constant";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDatePicker from '../commoncomponents/CustomDatePicker';
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
 import PageLoader from "../commoncomponents/PageLoader";
 import { v4 as uuidv4 } from 'uuid';

 const WorkOrderRescheduleList = ({ facilityId, companyId }) => {
  const dispatch = useDispatch();
  const [gridApi, setGridApi] = useState({});
  const [allRows, setAllRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rescheduleWorkOrder, setRescheduleWorkOrder] = useState([]);
  const [backDialogOpen, setBackDialogOpen] = useState();
  const navigate = useNavigate();
  const colDefs = [
    {
      field: "targetdate", headerName: "Reschedule To",

    },
    {
      field: "reason", headerName: "Reason",

    },
  ];
  const [workOrderNo, setWorkOrderNo] = useState();
  const [workOrderOptions, setWorkOrderOptions] = useState([]);
  const [data, setData] = useState({});
  const [ppmScheduleDate, setPpmScheduleDate] = useState(allRows?.[0]?.targetdate);
  const [scheduleDate, setScheduleDate] = useState(allRows?.[0]?.targetdate);
  const [getTargetDate, setGetTargetDate] = useState();
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [openResultsDialog, setOpenResultsDialog] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [confirmationSaveDialogOpen, setConfirmationSaveDialogOpen] = useState(false);
  const [loading,setLoading]=useState(true);

  const fetchOptions = async () => {
    try {
        setLoading(true);
        const workorderNoResponse = await workOrderResscheduleRepository.getWorkOrderOptions(facilityId);

        if (workorderNoResponse?.status !== "error") {
            const formattedOptions = workorderNoResponse?.map((item, index) => {
                const getService = item?.service === "FEMS" ? "fem" : "bem";
                return {
                    id: item?.id || "",
                    label: item?.label || "",
                    details: item?.requestdetails || "",
                    service: item?.service || "",
                    wgcode: item?.wgcode || "",
                    wgdesc: item?.wgdesc || "",
                    assetdesc: item?.assetdesc || "",
                    assetno: item?.assetno || "",
                    PPMDate: dateFormatChange(item?.[`${getService}ppmscheduletrack`]?.targetdate) || "",
                    workorderDate:dateFormatChange(item?.workorderdate) || "",
                    gridRows:item?.[`${getService}rescheduledworkorderheaders`] || []
                };
            });
            setWorkOrderOptions(formattedOptions);
        }
    } catch (e) {
        console.log(e);
    } finally {
        setLoading(false);
    }
};


useEffect(() => {
    fetchOptions()
  }, []);

  // useEffect(() => {
  //   if (allRows.length > 0) {
  //     console.log(allRows,"allrows");
      
  //     const lastRow = allRows[allRows.length - 1];
  //     console.log(lastRow,"lastrow");
      
  //     setPpmScheduleDate(lastRow.targetdate || '');
  //   }
  // }, [allRows,ppmScheduleDate]);

  const dateFormatChange = (dateString, type = '') => {

    if (!dateString) {
        // Return an empty string or a default value when dateString is undefined or empty
        return '';
    }

    try {
        if (type !== 'schedule') {
            const parsedDate = parseISO(dateString);
            const formattedDate = format(parsedDate, 'dd/MM/yyyy');
            return formattedDate;
        } else {
            // Parse the date string to a Date object
            const parsedDate = parse(dateString, 'EEE MMM dd yyyy HH:mm:ss \'GMT\'xxxxx (zzzz)', new Date());

            // Format the Date object to the desired string format
            const formattedDate = format(parsedDate, 'yyyy-MM-dd\'T\'HH:mm:ss');
            return formattedDate;
        }
    } catch (error) {
        console.error("Error parsing date:", error);
        // Return an empty string or a default value when parsing fails
        return '';
    }
};

  const fetchAllRows = async (id,service) => {
    try {
      if (workOrderNo != undefined && openResultsDialog === false) {
        const response = await workOrderResscheduleRepository.getAllRows(service || data?.service, id || workOrderNo?.id);
        if (response?.status !== "error") {
          const formattedRows = response?.map((item) => {
            return { ...item, targetdate: format(new Date(item?.targetdate), 'dd/MM/yyyy') }
          })          
          setPpmScheduleDate(formattedRows?.[0]?.targetdate || '');
          setScheduleDate(formattedRows?.[0]?.targetdate || '');
          setAllRows(formattedRows || []);
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }
console.log(ppmScheduleDate,"ppmScheduleDate");

  const handleCancelClick = () => {
    if (rescheduleWorkOrder?.length > 0) {
      setBackDialogOpen(true);
    } else {
      navigate('/dashboard');
      dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
      dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    }
  }


  const handleAddRow = () => {
    setOpenResultsDialog(true);
  };

  function AddRowButton(props) {
    const handleClick = () => {
      props.onClick();
    };
    return (<>
   {workOrderNo?.label != '' ?  (<Button variant='contained' onClick={handleClick}>
        Add
      </Button>):null}</>
    );
  }
  const handleDelete = (row) => {
    if(row?.id){
    setRowToDelete(row);
    setDeleteDialogOpen(true);
    }
  };

  const confirmDelete = async () => {
    try {
      if (rowToDelete?.localDelete) {
        const idForDelete = rowToDelete?.id;
        const updatedRows = allRows?.filter((row) => row?.id !== idForDelete);
        
        setAllRows(updatedRows);
        setDeleteDialogOpen(false);
        setRowToDelete(null);
        setDeleteDialogOpen(false);
        setConfirmationDialogOpen(true);
      } else {
        const idForDelete = rowToDelete?.id;
        const deleteRescheduledata = await workOrderResscheduleRepository?.deleteRescheduleWorkOrder(idForDelete,data?.service);
        if (deleteRescheduledata?.status <= 204) {
          const updatedRows = allRows?.filter((row) => row?.id !== idForDelete);
          setAllRows(updatedRows);
          fetchAllRows(workOrderNo?.id,data?.service);
          setRowToDelete(null);
          setDeleteDialogOpen(false);
          setConfirmationDialogOpen(true);
        }
      }

    }
    catch (e) {
      console.log(e);
    }
  };

  const confirmBack = async () => {
    navigate('/dashboard');
  }

  console.log(workOrderOptions,"workorderOptions");
  console.log(data,"data");
  

  const handleSaveClick = async () => {
    try {
      if (rescheduleWorkOrder?.length > 0) {
        const setTracks = rescheduleWorkOrder?.map(async (item) => {
          if(item?.id){
            const updatePpmScheduledDate = await workOrderResscheduleRepository.updateRescheduleWorkOrder(item?.id,item,data?.service);
            return updatePpmScheduledDate;
          } else {
            const rescheduleDate = await workOrderResscheduleRepository.rescheduleWorkOrder(item,data?.service);
            return rescheduleDate;
          }
        });
        const updatePpmScheduleTracksInsert = await Promise.all(setTracks)
        const allStatusForInsert = updatePpmScheduleTracksInsert.every(result => result.status <= 204);
        const API_Payload = {
          id:workOrderNo?.id || "",
          targetdate:getTargetDate || "",      
        }
        const updateWorkorderDate = await workOrderResscheduleRepository.updateWorkorderTargetDate(workOrderNo?.id,API_Payload,data?.service);
        
        if (allStatusForInsert && updateWorkorderDate?.status <= 204) {
          setRescheduleWorkOrder([]);
          setConfirmationSaveDialogOpen(true);
          fetchAllRows(workOrderNo?.id,data?.service);
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  };
  console.log(workOrderNo,"workOrderNo");

  const ResultsDialog = ({ open, onClose, onConfirm }) => {
    const [reason, setReason] = useState();
    const [rescheduleDate, setRescheduleDate] = useState();
    const [errors, setErrors] = useState({});

    const handleAdd = async () => {
      const newErrors = {};
      const parsedDate = rescheduleDate && parse(rescheduleDate, 'dd/MM/yyyy', new Date());
      // Format the parsed date into the desired ISO 8601 format
      const formattedDate = parsedDate && format(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSS");
      if (!reason) newErrors.reason = "Reason is required";
      if (!rescheduleDate) newErrors.rescheduleDate = "Reschedule To is required";
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        const getService = data?.service === "FEMS" ? "fem" : "bem";        
        const values = {
          "isdeleted": false,
          "targetdate": rescheduleDate,
          "reason": reason,
          [`${getService}scheduledworkorderheaderId`]: workOrderNo?.id,
          "localDelete": true,
          "id": uuidv4()
        }
        const valueForSave = {
          "isdeleted": false,
          "targetdate": formattedDate,
          "reason": reason,
          [`${getService}scheduledworkorderheaderId`]: workOrderNo?.id,
        }
        setRescheduleWorkOrder([valueForSave, ...rescheduleWorkOrder]);
        setAllRows([values, ...allRows]);
        setGetTargetDate(formattedDate);
        setPpmScheduleDate(rescheduleDate);
        setScheduleDate(rescheduleDate);
        onClose();
      }
    }

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 'bold', padding: '16px' }}>Reschedule Work Order</DialogTitle>
        <DialogContent>

          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <CustomDatePicker label="Reschedule To" isStatrtDate={true} dissablePastDate={true} id={"warranty-start-date"}
                modal={open}
                isMandatoryField={true}
                value={rescheduleDate}
                autoFocus={true}
                error={!!errors?.rescheduleDate}
                errorMessage={errors?.rescheduleDate}
                onDateChange={(newValue) => {
                  setRescheduleDate(newValue)
                  setErrors({ ...errors, rescheduleDate: null });

                }}
              />

            </Grid>
            <Grid item xs={6} md={6}>
              <CustomTextField
                label="Work Order No."
                isRefilByOtherField={true}
                placeholder={false}
                value={workOrderNo?.label}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <CustomTextField
                label="Reason"
                isMandatoryField={true}
                placeholder={false}
                errorMessage={errors?.reason}
                error={!!errors.reason}
                value={reason}
                onChange={(newValue) => {
                  setReason(newValue)
                  setErrors({ ...errors, reason: "" });
                }}
              /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleAdd} color="primary" sx={{ margin: "10px" }}>
            ADD
          </Button>
          <Button variant="outlined" onClick={onClose} color="primary" sx={{ margin: "10px" }}>
            Cancel
          </Button>

        </DialogActions>
      </Dialog>
    )
  };

  return (
    <>
         <PageLoader open={loading} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>

            <Grid item xs={6} md={4}>
              <CustomTextFieldWithSearch
                label="Work Order No."
                name="WorkOrderNo"
                id="WorkOrderNo"
                value={workOrderNo}
                options={workOrderOptions}
                autoFocus={true}
                onChange={(newValue) => {
                  
                  if(newValue?.label==''){
                    setPpmScheduleDate('');
                    setScheduleDate('');
                    setAllRows([]);
                    setData({})
                    setWorkOrderNo("")
                  } else {
                    
                  setWorkOrderNo(newValue)
                  setData(newValue)
                  // setAllRows(newValue?.gridRows?.map((item) => {
                  //   return { ...item, targetdate: format(new Date(item?.targetdate), 'dd/MM/yyyy') }
                  // }));
                  fetchAllRows(newValue?.id,newValue?.service);

                  }
                }
                }
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Work Order Date"
                name="workorderdate"
                isRefilByOtherField={true}
                placeholder={false}
                value={data?.workorderDate || ""}
                onChange={(newValue) => {

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Details"
                name="details"
                isRefilByOtherField={true}
                placeholder={false}
                value={data?.details ||""}
                onChange={(newValue) => {
                }}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextField
                label="PPM Date"
                name="ppm date"
                isRefilByOtherField={true}
                placeholder={false}
                value={data?.PPMDate || ""}
                onChange={(newValue) => {
                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Next Schedule Date"
                name="Next Schedule Date"
                isRefilByOtherField={true}
                placeholder={false}
                // value={allRows?.[0]?.targetdate}
                value={ppmScheduleDate}
                onChange={(newValue) => {

                }}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Schedule Date"
                name="Schedule Date"
                isRefilByOtherField={true}
                placeholder={false}
                // value={allRows?.[0]?.targetdate}
                value={scheduleDate}
                onChange={(newValue) => {

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Asset No."
                name="asset no"
                isRefilByOtherField={true}
                placeholder={false}
                value={data?.assetno || ""}
                onChange={(newValue) => {

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Asset Description"
                name="Asset Description"
                isRefilByOtherField={true}
                placeholder={false}
                value={data?.assetdesc || ""}
                onChange={(newValue) => {

                }}
              />
            </Grid>
          </Grid>
        </DefaultCard></Box>
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          {(workOrderNo?.id) && ( <Grid container spacing={2}>
            <Grid item xs={4} md={12} sx={{ marginBottom: "10px", display: "flex", justifyContent: "flex-end" }}>  <AddRowButton onClick={handleAddRow} /> </Grid>
            </Grid>)}
          <CustomAgGrid
            ref={gridApi}
            setGridApi={setGridApi}
            rows={allRows}
            columns={colDefs}
            isEnableView={false}
            disableFilter={false}
            // handleDelete={allRows?.length === 1 ? null : handleDelete}
          />
        </DefaultCard>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: { xs: "center", md: "end" },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: "60px", marginRight: "20px" }}>
            {((workOrderNo?.id) && !(allRows?.length < 1)) ? (<Button variant='contained' onClick={handleSaveClick} sx={{ marginRight: "10px" }} >Save</Button>) : null }
            <Button variant='outlined' onClick={handleCancelClick}>BACK</Button>

            </Grid>
          </Grid>
        </Box>

      </Box>
      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        content={<>
          {commonMessages.deleteConfirmationMessage}
        </>}
        cancelBtn='No'
        confirmBtn="Yes"
      />
      <CustomDialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        content= {commonMessages.deleteSuccessMessage}      
        confirmBtn="OK"
        onConfirm={() => setConfirmationDialogOpen(false)}
      />
   <CustomDialog
        open={confirmationSaveDialogOpen}
        onClose={() => setConfirmationSaveDialogOpen(false)}
        content= {commonMessages.saveSuccessmessage}      
        confirmBtn="OK"
        onConfirm={() => setConfirmationSaveDialogOpen(false)}
      />
      <CustomDialog
        open={backDialogOpen}
        onClose={() => setBackDialogOpen(false)}
        onConfirm={confirmBack}
        content={<>{commonMessages.confirmBackMessage}</>}
        cancelBtn='No'
        confirmBtn="Yes"
      />

      <ResultsDialog
        open={openResultsDialog}
        onClose={() => setOpenResultsDialog(false)}
      />

    </>
  )
};
export default WorkOrderRescheduleList